import React, { useEffect, useRef, useState } from "react";
import { useAIAskMeContext } from "../../../context/ai-ask-me.context";
import { getUUID } from "../../../helper/helper";
import images from "../../../helper/images";
import {
  postChatboxQuestion,
  getChatboxQuestionDetails,
} from "../../../service/ai-model.service";
import QueryItem from "./QueryItem";

const ChatQueyResult = (props) => {
  const { currentQuery, updateCurrentQuery, showModal, activeUUID, updateCurrentQueryUUID } =
    useAIAskMeContext();
  const [queryList, setQueryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const listRef = useRef(null);

  useEffect(() => {
    if (showModal && currentQuery) {
      setLoading(true);
      const payload = {
        uuid: activeUUID || getUUID(),
        user_input: currentQuery
      };
      postChatboxQuestion(payload)
        .then((data) => {
          const list = queryList.slice();
          const item = {
            uuid: payload.uuid,
            query: payload.user_input
          };
          item.responses = [data?.response];
          updateCurrentQuery("");
          list.push(item);
          setQueryList(list);
          updateCurrentQueryUUID(payload.uuid);
        })
        .catch((ex) => ex)
        .finally((ex) => setLoading(false));
    }
    if (!showModal) {
      updateCurrentQuery("");
      setQueryList([]);
    }
  }, [currentQuery, showModal]);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  }, [queryList]);

  useEffect(() => {
    if (activeUUID) {
      setQueryList([]);
      setLoading(true);
      getChatboxQuestionDetails({ sessionId: activeUUID })
        .then((data) => {
          if (data && data.length) {
            setQueryList(data.reverse());
          }
        })
        .catch((e) => e)
        .finally(() => setLoading(false));
    } else {
      setQueryList([]);
      setLoading(false);
    }
  }, [activeUUID]);

  const renderQueryList = () => {
    if (showModal && queryList && queryList.length) {
      return (
        <>
          {queryList.map((query, index) => {
            const data = {
              user_input: query.query,
              result: query.responses[0],
              timestamp: query.timestamp

            }
            return <QueryItem key={index} query={data} index={index} />;
          })}
          <div ref={listRef} />
        </>
      );
    }
  };

  const renderInlineLoader = () => {
    return (
      <div className="ask-me-loader-container">
        <img src={images.loaderGif} width="50px" alt="" />
      </div>
    );
  };

  const renderQueryResults = () => {
    return (
      <div className="chtbot-results" >
        <h3 className="text-white pb-3">Query Results</h3>
        {renderQueryList()}
        {loading && renderInlineLoader()}
      </div>
    );
  };
  const render = () => {
    return (
      <div className="chtbotmidsec text-white">
        {renderQueryResults()}
      </div>
    );
  };
  return render();
};

export default ChatQueyResult;
